import { CSSProperties, StyleSheet } from 'aphrodite';
import { brandPrimaryHover, brandSecondary, titles } from '../../../web/styles/colors';
import { baseStyles } from '../../../web/styles/styles';

// import { CssSelectors } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	contactIdInput: {
		...(baseStyles.textField as CSSProperties),
		borderRadius: 8,
		marginBottom: 16,
		width: '100%',
	},
	contactIdInputWrapper: {
		marginBottom: 16,
		width: '100%',
	},
	continueButton: {
		minWidth: '136px !important',
	},
	copyLinkButton: {
		border: `1px solid ${brandPrimaryHover}`,
		borderRadius: 3,
		display: 'inline-flex',
		justifyContent: 'center',
		margin: '0 8px',
		padding: '10px 20px',
		textDecoration: 'none !important',
	},
	footer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
	},
	selectTrigger: {
		...(baseStyles.textField as CSSProperties),
		height: 30,
		minWidth: 340,
		marginBottom: 16,
	},
	heading: {
		color: brandSecondary,
		fontSize: 18,
		margin: '19px 0 11px 0',
	},
	radioButtonsWrap: {
		display: 'flex',
		gap: 8,
		flexWrap: 'wrap',
		marginBottom: 18,
		maxWidth: 350,
	},
	text: {
		color: titles,
		fontSize: 14,
		margin: '0 0 22px',
	},
	wrapper: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		padding: '0px 33px 20px',
	},
});
